/* Change this file to get your personal Porfolio */

const settings = {
  isSplash: false,
};

const theme = {
  primaryTheme: "#6C63FF",
  secondaryTheme: "#55198b",
  easing: "cubic-bezier(0.645, 0.045, 0.355, 1)",
};

const greeting = {
  /* Your Summary And Greeting Section */
  title: "Hey all 👋 I'm Kuljeet Singh",
  nickname: "Software Engineer",
  subTitle:
    "A passionate Full Stack Developer 🚀 having an experience of building Web and Android applications with JavaScript / Reactjs / Nodejs / React-Native / MySQL and some other cool libraries and frameworks.",
  otherText: `👇 Hit in your console or terminal to connect with me. 🐱‍🚀`,
  consoleText: `npx kuljeet`,
  resumeLink:
    "https://drive.google.com/file/d/1Ho_LdVAw1KTF3FYjbgd4QqYDQIGNSsyx/view?usp=sharing",
  email: "kuljeetsingh951@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/Kuljeet-123",
  linkedin: "https://www.linkedin.com/in/kuljeet-singh-21836517a/",
  gmail: "kuljeetsingh@gmail.com",
  gitlab: "https://gitlab.com/kuljeetsingh951",
  facebook: "https://www.facebook.com/profile.php?id=100020808185256",
  twitter: "https://twitter.com/Kuljeet_123",
  instagram: "https://www.instagram.com/kuljeet5880/",
  codepen: "https://codepen.io/kuljeet-123",
  freecodecamp: "https://www.freecodecamp.org/kuljeet_singh",
  medium: "https://medium.com/@kuljeetsingh951",
};

const skills = {
  data: [
    {
      title: "Front End Development",
      imagePath: "manOnTable.png",
      skills: [
        "⚡ Building resposive website front end using React-Redux and bootstrap",
        "⚡ Production and maintenance of websites and web application user interfaces",
        "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications",
      ],
      softwareSkills: [
        {
          skillName: "HTML",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "CSS",
          fontAwesomeClassname: "fa-css3",
          style: {
            backgroundColor: "white",
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "transparent",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            backgroundColor: "transparent",
            color: "#61DAFB",
          },
        },
        {
          skillName: "Redux",
          fontAwesomeClassname: "simple-icons:redux",
          style: {
            backgroundColor: "transparent",
            color: "#69359c",
          },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: {
            color: "#563d7c",
          },
        },
        {
          skillName: "Material-UI",
          fontAwesomeClassname: "simple-icons:material-ui",
          style: {
            color: "#03A9F4",
          },
        },
      ],
    },
    {
      title: "Backend Development",
      imagePath: "cloud_infrastructure.svg",
      skills: [
        "⚡ Design and implement APIs in support of front-end services and help create a highly scalable, flexible, and secure backend.",
        "⚡ Collaborating with front-end developers on the integration of elements.",
        "⚡ Keeping informed of advancements in the field of Node.js development.",
      ],
      softwareSkills: [
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "ExpressJS",
          fontAwesomeClassname: "fa-envira",
          style: {
            color: "green",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#00758f",
          },
        },
        {
          skillName: "Loopback",
          fontAwesomeClassname: "simple-icons:loop",
          style: {
            color: "#1a82ff",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Apache Solr",
          fontAwesomeClassname: "simple-icons:apachesolr",
          style: {
            color: "#D9411E",
          },
        },
      ],
    },
    {
      title: "Full Stack Development",
      imagePath: "developerActivity.svg",
      skills: [
        "⚡ Creating application backend in Node, Express & PHP",
        "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: {
            color: "#563d7c",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "React-native",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Redux",
          fontAwesomeClassname: "simple-icons:redux",
          style: {
            color: "#8ea116",
          },
        },
        {
          skillName: "Redux-Saga",
          fontAwesomeClassname: "simple-icons:redux-saga",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "Material-UI",
          fontAwesomeClassname: "simple-icons:material-ui",
          style: {
            color: "#03A9F4",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#3fa037",
          },
        },
        {
          skillName: "ExpressJS",
          fontAwesomeClassname: "fa-envira",
          style: {
            color: "green",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#00758f",
          },
        },
        {
          skillName: "Loopback",
          fontAwesomeClassname: "simple-icons:loop",
          style: {
            color: "#1a82ff",
          },
        },
        {
          skillName: "Storybook",
          fontAwesomeClassname: "simple-icons:storybook",
          style: {
            color: "#FF4785",
          },
        },
      ],
    },
    {
      title: "App Development",
      imagePath: "design.png",
      skills: [
        "⚡  Responsible for building native applications that can run on multiple platforms such as Android, iOS, or Windows.",
        "⚡ Create reusable, effective, and scalable JavaScript code.",
        "⚡ Leverage native APIs for deep integrations with both platforms.",
      ],
      softwareSkills: [
        {
          skillName: "React-native",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Redux",
          fontAwesomeClassname: "simple-icons:redux",
          style: {
            color: "#8ea116",
          },
        },
        {
          skillName: "Redux-Saga",
          fontAwesomeClassname: "simple-icons:redux-saga",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "Storybook",
          fontAwesomeClassname: "simple-icons:storybook",
          style: {
            color: "#FF4785",
          },
        },
      ],
    },
  ],
};

const skillSet = {
  data: [
    {
      title: "Skills and Tools",
      imagePath: "programmer.svg",
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "Apache Solr",
          fontAwesomeClassname: "simple-icons:apachesolr",
          style: {
            color: "#D9411E",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: {
            color: "#563d7c",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "jQuery",
          fontAwesomeClassname: "simple-icons:jquery",
          style: {
            color: "#0769ad",
          },
        },
        {
          skillName: "Material-UI",
          fontAwesomeClassname: "simple-icons:material-ui",
          style: {
            color: "#03A9F4",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#3fa037",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#6567a5",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#00758f",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#213e97",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#f1502f",
          },
        },
        {
          skillName: "Github",
          fontAwesomeClassname: "simple-icons:github",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "Bit-Bucket",
          fontAwesomeClassname: "fa-bitbucket",
          style: {
            color: "#205081",
          },
        },
        {
          skillName: "VSCode",
          fontAwesomeClassname: "fa-code",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "Gitlab",
          fontAwesomeClassname: "fa-github-alt",
          style: {
            color: "#fca326",
          },
        },
        {
          skillName: "ExpressJS",
          fontAwesomeClassname: "fa-envira",
          style: {
            color: "green",
          },
        },
        {
          skillName: "Redux-Saga",
          fontAwesomeClassname: "simple-icons:redux-saga",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "Storybook",
          fontAwesomeClassname: "simple-icons:storybook",
          style: {
            color: "#FF4785",
          },
        },
      ],
    },
  ],
};

const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/anonymousss_123",
    },
    {
      siteName: "Geeksforgeeks",
      iconifyClassname: "simple-icons:goodreads",
      style: {
        color: "#2ec866",
      },
      profileLink: "https://auth.geeksforgeeks.org/user/kuljeetsingh3/profile",
    },
    {
      siteName: "InterviewBit",
      iconifyClassname: "fa-info",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "https://www.interviewbit.com/profile/kuljeet-singh",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@kuljeetsingh951",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Guru Tegh Bahadur Institute Of Technology, New Delhi",
      subtitle: "B.Tech. in Information Technology",
      logo_path: "gtbit-logo.jfif",
      alt_name: "GTBIT",
      duration: "2017 - 2021",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CD, AI etc.",
        "⚡ Apart from this, I have done courses on Machine Learning, Cloud Computing and Full Stack Web Development.",
        "⚡ I was Awarded as Mr. Singh in the GTBIT GATES FEST 2k19.",
      ],
      website_link: "https://www.gtbit.org/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Fullstack Development",
      subtitle: "- Jogesh Muppala",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/certificate/WQHVN9YM4EN7",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Server-side Development with NodeJS,Express and MongoDB",
      subtitle: "- Jogesh Muppala",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/CJEKFUMARV75",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Multiplatform Mobile App Development with React Native",
      subtitle: "- Jogesh Muppala",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/THTFCQ9WS6RC",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Front End Web Development with React",
      subtitle: "- Jogesh Muppala",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/FT6V5G5CBGD6",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Front-End Web UI Frameworks and Tools: Bootstrap 4",
      subtitle: "- Jogesh Muppala",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/B4HCDX5WK2AZ",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Full Stack Developer",
      subtitle: "- freeCodeCamp",
      logo_path: "freecodecamp.png",
      certificate_link:
        "https://www.freecodecamp.org/certification/kuljeet_singh/full-stack",
      alt_name: "full stack",
      color_code: "#00471b",
    },
    {
      title: "Information Security and Quality Assurance",
      subtitle: "- freeCodeCamp",
      logo_path: "freecodecamp.png",
      certificate_link:
        "https://www.freecodecamp.org/certification/kuljeet_singh/information-security-and-quality-assurance",
      alt_name: "information security",
      color_code: "#00471b",
    },
    {
      title: "APIs and Microservices",
      subtitle: "- freeCodeCamp",
      logo_path: "freecodecamp.png",
      certificate_link:
        "https://www.freecodecamp.org/certification/kuljeet_singh/apis-and-microservices",
      alt_name: "apis and microservices",
      color_code: "#00471b",
    },
    {
      title: "Data Visualization",
      subtitle: "- freeCodeCamp",
      logo_path: "freecodecamp.png",
      certificate_link:
        "https://www.freecodecamp.org/certification/kuljeet_singh/data-visualization",
      alt_name: "data visualization",
      color_code: "#00471b",
    },
    {
      title: "Front End Libraries",
      subtitle: "- freeCodeCamp",
      logo_path: "freecodecamp.png",
      certificate_link:
        "https://www.freecodecamp.org/certification/kuljeet_singh/front-end-libraries",
      alt_name: "front-end libraries",
      color_code: "#00471b",
    },
    {
      title: "JavaScript Algorithms and Data Structures",
      subtitle: "- freeCodeCamp",
      logo_path: "freecodecamp.png",
      certificate_link:
        "https://www.freecodecamp.org/certification/kuljeet_singh/javascript-algorithms-and-data-structures",
      alt_name: "JS algorithms",
      color_code: "#00471b",
    },
    {
      title: "Responsive Web Design",
      subtitle: "- freeCodeCamp",
      logo_path: "freecodecamp.png",
      certificate_link:
        "https://www.freecodecamp.org/certification/kuljeet_singh/responsive-web-design",
      alt_name: "responsive web design",
      color_code: "#00471b",
    },
    {
      title: "Algorithmic Toolbox",
      subtitle: "- Daniel M. Kane",
      logo_path: "sandigo-logo.jfif",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/records/24QCLZBH356T",
      alt_name: "Algorithms",
      color_code: "#420a192f",
    },
    {
      title: "C++ For C Programmers, Part A",
      subtitle: "- Ira Pohl",
      logo_path: "santa-logo.jpg",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/records/DYCKM9DY7JBJ",
      alt_name: "C++",
      color_code: "#42000000",
    },
  ],
};

const openSource = {
  /* Your Open Source Section to View Your Github Pinned Projects */
  /* To know how to get github key look at readme.md */

  githubConvertedToken: "Your Github Converted Token",
  githubUserName: "Your Github Username",
};

const bigProjects = {
  /* Some Big Projects You have worked with your company */
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELP TO CREATE THEIR TECH",
  projects: [
    {
      image: "https://drive.google.com/uc?id=1exWn9T6j8TsfDDHJnS3VR66eP6RiGAfY",
      link: "http://saayahealth.com/",
    },
    {
      image: "http://nextu.se/wp-content/themes/nextu/images/og_img.jpg",
      link: "http://nextu.se/",
    },
  ],
};

const achievementSection = {
  /* Your Achievement Section Include Your Certification Talks and More */

  title: "Achievements And Certifications 🏆 ",
  subtitle:
    "Achievements, Certifications Award Letters and Some Cool Stuff that i have done !",

  achivementsCards: [
    {
      title: "Google Code-In Finalist",
      description:
        "First Pakistani to be selected as Google Google-in Finalist from 4000 students from 77 diffrent countries",
      image:
        "https://1.bp.blogspot.com/-Ig-v1tDXZt4/XDODmZvWp1I/AAAAAAAAB0A/KtbFdBPFVQw2O15FekkIR0Yg8MUp--rngCLcBGAs/s1600/GCI%2B-%2BVertical%2B-%2BGray%2BText%2B-%2BWhite%2BBG.png",
      footerLink: [
        {
          name: "Certification",
          url:
            "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing",
        },
        {
          name: "Award Letter",
          url:
            "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing",
        },
        {
          name: "Google Code-in Blog",
          url:
            "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html",
        },
      ],
    },
    {
      title: "Google Assistant Action",
      description:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Google_Assistant_logo.svg/1200px-Google_Assistant_logo.svg.png",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url:
            "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en",
        },
      ],
    },

    {
      title: "PWA Web App Developer",
      description:
        "Completed Certifcation from SMIT for PWA Web App Development",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRu93Bd6LDbxPEOXr-hfLqLYzmHny8c0MJoI3exQP-lwpFLRT7g&s",
      footerLink: [
        { name: "Certification", url: "" },
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/",
        },
      ],
    },
  ],
};

// const blogSection = {
//   /* Blogs Section */

//   title: "Blogs",
//   subtitle:
//     "With love for individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
//   link: "https://ashutoshhathidara.wordpress.com",
//   avatar_image_path: "blogs_image.svg"

// };

// // Talks Sections

// const talkSection = {
//   title: "TALKS",
//   subtitle: "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅",

//   talks: [
//     {
//       title: "Build Actions For Google Assistant",
//       subtitle: "Codelab at GDG DevFest Karachi 2019",
//       slides_url: "https://bit.ly/saadpasta-slides",
//       event_url: "https://www.facebook.com/events/2339906106275053/",
//       image:
//         "https://scontent.fkhi6-1.fna.fbcdn.net/v/t1.0-9/76714032_1730516240415559_1293494289556307968_o.jpg?_nc_cat=103&_nc_ohc=s5f81rdZd6wAQmqUa52YQBA21MjVOy7e-HN9jI7MspRDC-v5ahEouyInQ&_nc_ht=scontent.fkhi6-1.fna&oh=c29141a9a0de7ff2011a8191f5475a78&oe=5E83127C"
//     }
//   ]
// };

// // Podcast Section
// const podcastSection = {
//   title: "Podcast 🎙️",
//   subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

//   // Please Provide with Your Podcast embeded Link
//   podcast: [
//     "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
//   ]
// };

// const contactInfo = {
//   title: "Contact Me ☎️",
//   subtitle: "Discuss a project or just want to say hi my inbox is open for all",
//   number: "+92-3243454077",
//   email_address: "saadpasta70@gmail.com"
// };

export {
  settings,
  theme,
  greeting,
  socialMediaLinks,
  skills,
  skillSet,
  competitiveSites,
  degrees,
  certifications,
  openSource,
  bigProjects,
  achievementSection,
  // blogSection,
  // talkSection,
  // podcastSection,
  // contactInfo
};
